<div class="time__container">
  <input type="time" [(ngModel)]="value" />
</div>
